import React from 'react';

import Head from 'next/head';
import BrandLayout from '../components/brand/BrandLayout';
import About from '../components/brand/About';

export default function AboutUs() {
  return (
    <BrandLayout>
      <Head>
        <title>AfricaSasa Merchant | About Us</title>
      </Head>
      <About />
    </BrandLayout>
  );
}
